import dayjs from 'dayjs'
import { DurationUnitsObjectType } from 'dayjs/plugin/duration'
import { IcsCalendar } from 'ts-ics'

import { useLocalization } from '@/shared/composables/localization'

import { TIME_FORMAT, BIRTH_DAY_DATE_TIME_FORMAT } from '../constants/date-time'

/** RFC 5545 calendar component names — IM may send these as appointmentName when SUMMARY is empty. */
const icsCalendarComponentName = {
  VCALENDAR: 'VCALENDAR',
  VEVENT: 'VEVENT',
  VTODO: 'VTODO',
  VJOURNAL: 'VJOURNAL',
  VFREEBUSY: 'VFREEBUSY',
  VTIMEZONE: 'VTIMEZONE',
  VALARM: 'VALARM',
} as const

const icsCalendarComponentNames = new Set<string>(Object.values(icsCalendarComponentName))

export const isIcsCalendarComponentName = (value: string): boolean => (
  icsCalendarComponentNames.has(value.trim().toUpperCase())
)

export const getScheduleEventDisplayName = (summary: string | undefined, fallback: string): string => {
  const trimmedSummary = summary?.trim()
  if (!trimmedSummary || isIcsCalendarComponentName(trimmedSummary)) {
    return fallback
  }
  return trimmedSummary
}

export const scheduleToTextMessage = (schedule: IcsCalendar): string => {
  const { t } = useLocalization()
  const { events = [] } = schedule

  if (events.length === 0) {
    return ''
  }

  const { start, duration } = events[0] ?? { start: { date: '' }, duration: { seconds: 0, minutes: 0, hours: 0 } as DurationUnitsObjectType }

  if (!start.date || !duration) {
    return ''
  }

  const { seconds = 0, minutes = 0, hours = 0 } = duration
  const durationUnits: DurationUnitsObjectType = {
    seconds,
    minutes,
    hours,
  }

  const durationTime = dayjs.duration(durationUnits).format(TIME_FORMAT)
  return `${dayjs(start.date).format(BIRTH_DAY_DATE_TIME_FORMAT)}. ${t('common.duration')} — ${durationTime}`
}
